export enum ShutterStreetOrientationPreference {
  FRONT = "FRONT",
  NOT_BACK = "NOT_BACK",
  ALL = "ALL",
}
export interface ShutterGap {
  windowId: string;
  start: number;
  width: number;
  bottom: number;
  height: number;
  extendedStart: number;
  extendedWidth: number;
  extendedBottom: number;
  extendedHeight: number;
}
